import {postFetch} from '~commonApi';
import {API_SERVERLESS} from '../../commonApi';

export function apiDefinePassword(jsonData: any) {
    //TODO: review
    return postFetch(`${API_SERVERLESS}/common/v3/definePassword`, true, jsonData);
}
